import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { getCurrentLanguageFromCookie } from 'srcReact/helpers/utils'

export const supportService = {
  getTickets,
  getTicketById,
  postTicket,
  updateTicket
}

function getTickets(orgId, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(
    `/v2/support/tickets/list?id_organization=${orgId}&offset=${offset}&quantity=${quantity}`,
    requestOptions
  )
}

function getTicketById(orgId, ticketId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/support/ticket/get?id_organization=${orgId}&id_support_ticket=${ticketId}`, requestOptions)
}

function postTicket(form) {
  const is_logged = isUserAuthorized() ? 1 : 0
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: form
  }
  return doRequestAxios(`/v2/support/ticket/message/send/${is_logged}?language=${language}`, requestOptions)
}

function updateTicket(ticketId, action, message, fileIds) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      slug: 'support/open_tickets',
      id_support_ticket: ticketId,
      action,
      message,
      file_ids: fileIds
    }
  }
  return doRequestAxios(`/v2/back-office/support/ticket/update`, requestOptions)
}
